<template>
  <div class="page-shell">
    <PageBanner
      eyebrow="GALLERY"
      background-image="/page/gallery-banner.jpg"
      :title="{ 'zh-CN': '企业风貌', 'en-US': 'Gallery' }"
    />
    <section class="section">
      <div class="container">
<!--        <SectionTitle-->
<!--          eyebrow="GALLERY"-->
<!--          :title="{ 'zh-CN': '企业风貌', 'en-US': 'Gallery' }"-->
<!--          :description="{ 'zh-CN': '当前为相册型布局，可继续替换为真实企业图片。', 'en-US': 'Currently an album-style layout, ready for real company images.' }"-->
<!--        />-->
        <div class="case-heading">
          <span>GALLERY</span>
          <!--          <h2>{{ $pick({ "zh-CN": "工程案例", "en-US": "Project Cases" }) }}</h2>-->
          <p>
            {{ $pick({
            "zh-CN": "源头厂家・实力工厂・专注整体输配电解决方案",
            "en-US": "Source manufacturer, strong factory. Expert in integrated power transmission and distribution solutions."
          }) }}
          </p>
        </div>
        <div class="gallery-grid">
          <article v-for="item in galleryItems" :key="$pick(item)" class="gallery-card">
            <div class="gallery-thumb">
              <img :src="item.image" :alt="$pick(item)" loading="lazy" />
            </div>
            <h3>{{ $pick(item) }}</h3>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageBanner from "../../components/common/PageBanner.vue";
import SectionTitle from "../../components/common/SectionTitle.vue";
import { galleryItems } from "../../data/site";

export default {
  name: "GalleryPage",
  components: { PageBanner, SectionTitle },
  data() {
    return {
      galleryItems
    };
  }
};
</script>

<style scoped>
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

.gallery-card {
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
}

.gallery-thumb {
  height: 220px;
  background: linear-gradient(135deg, #cfe0f6, #eff5fc);
  overflow: hidden;
}

.gallery-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.42s ease, filter 0.42s ease;
}

.gallery-card:hover .gallery-thumb img {
  transform: scale(1.045);
  filter: saturate(1.06) contrast(1.03);
}

.gallery-card h3 {
  margin: 0;
  padding: 18px;
  color: var(--brand-blue-deep);
}

@media (max-width: 900px) {
  .gallery-grid {
    grid-template-columns: 1fr;
  }
}
.case-heading {
  position: relative;
  margin-bottom: 30px;
  padding-top: 16px;
  border-top: 2px solid #1c78df;
}

.case-heading::before {
  content: "";
  position: absolute;
  top: -2px;
  left: 0;
  width: 270px;
  height: 11px;
  background: linear-gradient(90deg, #0b66d8, #31a9ff);
  clip-path: polygon(0 0, 92% 0, 100% 100%, 0 100%);
}

.case-heading span {
  display: inline-block;
  margin-top: 18px;
  color: var(--brand-blue-soft);
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.case-heading h2 {
  margin: 8px 0 10px;
  color: var(--brand-blue-deep);
  font-size: clamp(30px, 4vw, 44px);
  line-height: 1.15;
}

.case-heading p {
  max-width: 760px;
  margin: 0;
  color: #657284;
  line-height: 1.8;
}
</style>
